import React from 'react';
import PropTypes from 'prop-types';
import './styles/blinking-lights.scss';
import { Fragment } from 'react';

const BlinkingLightsView = ({
  name, blinking
}) => {

  return (
    <div className="lights">
        <div className="light">
            {blinking ? <div className="inner-light blink"/> : <Fragment/>}
        </div>
        <div className="spacer"/>
        <div className="light">
            {blinking ? <div className="inner-light blink"/> : <Fragment/>}
        </div>
    </div>
  );
};

BlinkingLightsView.propTypes = {
  name: PropTypes.string,
  blinking: PropTypes.bool.isRequired
};

export default BlinkingLightsView;